import {
  KikErrorCodes,
  KikErrorMessages,
  KikErrorResponse,
  KikGenericResponseBase,
  KikMarketingCloudValidationResponse,
  KikRestVerbs,
} from "@kikocosmeticsorg/uc-api-nest-common-fe";

import { HttpService } from "~/services/http";
import Logger from "~/services/logger/logger";
import { ApiConstants } from "~/shared/api/api-constants.class";

export class MarketingCloudService {
  static validateEmail(email: string) {
    Logger.instance.debug(`MarketingCloudService: validating email ${email}`);

    return HttpService.$http<KikGenericResponseBase<KikMarketingCloudValidationResponse>>({
      ttl: 999, // Since this cache is session, we can cache indefinitely
      method: KikRestVerbs.POST,
      url: ApiConstants.endpointsV2.authValidateEmail,
      body: {
        email: email,
      },
    }).then((validationResponse) => {
      if (!validationResponse.data!.valid) {
        throw KikErrorResponse.create({
          messages: KikErrorMessages.MARKETING_CLOUD_INVALID_EMAIL,
          errorCode: KikErrorCodes.MARKETING_CLOUD_INVALID_EMAIL,
        });
      }
    });
  }
}
